import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify';

const ViewBuying = () => {
    const params = useParams();
    const id = params.id;


    const [purchased, setPurchased] = useState();
    const getPurchasedInfo = async () => {
        try {
            const response = await axios.get(`/buy/${id}`)
            if (response.data.success) {
                setPurchased(response.data.buying);
            }
        } catch (error) {
            toast.error(error.response.data.message)
        }
    }

    useEffect(() => {
        getPurchasedInfo();
    }, [])


    return (
        <>
            <div>
                <div className='mx-6 my-10 space-y-3 bg-gray-100 p-5 rounded-lg'>
                    <h1 className='text-2xl font-bold italic'>Distributor details: </h1><hr />
                    <h2><span className='font-bold'>Name: </span>{purchased?.distributor?.name}</h2>
                    <h2><span className='font-bold'>Contact: </span>{purchased?.distributor?.contact}</h2>
                    <h2><span className='font-bold'>Address: </span>{purchased?.distributor?.address}</h2>
                </div>

                <div class="relative flex flex-col w-full h-full overflow-scroll text-gray-700 bg-white shadow-md rounded-lg bg-clip-border">
                    <table class="text-left table-auto text-slate-800">
                        <thead>
                            <tr class="text-slate-800 border-b border-slate-300 bg-slate-50">
                                <th class="p-4">
                                    <p class="text-sm leading-none font-bold">
                                        Product Name
                                    </p>
                                </th>
                                <th class="p-4">
                                    <p class="text-sm leading-none font-bold">
                                        Quantity
                                    </p>
                                </th>
                                <th class="p-4">
                                    <p class="text-sm leading-none font-bold">
                                        Purchased Price
                                    </p>
                                </th>
                                <th class="p-4">
                                    <p class="text-sm leading-none font-bold">
                                        GST
                                    </p>
                                </th>
                                <th class="p-4">
                                    <p class="text-sm leading-none font-bold">
                                        Total Price
                                    </p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                purchased?.products?.map((p) => {
                                    return (
                                        <>
                                            <tr class="hover:bg-slate-50">
                                                <td class="p-4">
                                                    <p class="text-sm font-bold">
                                                        {p?.product?.name}
                                                    </p>
                                                </td>
                                                <td class="p-4">
                                                    <p class="text-sm">
                                                        {p?.quantity}
                                                    </p>
                                                </td>
                                                <td class="p-4">
                                                    <p class="text-sm">
                                                        {p?.price}
                                                    </p>
                                                </td>
                                                <td class="p-4">
                                                    <p class="text-sm">
                                                        {p?.buyingGst}%
                                                    </p>
                                                </td>
                                                <td class="p-4">
                                                    <p class="text-sm">
                                                        {p?.total.toLocaleString("en-IN")}
                                                    </p>
                                                </td>
                                            </tr>
                                        </>
                                    )
                                })
                            }


                        </tbody>
                    </table>

                </div>


                <div className='mx-6 my-10 space-y-3 bg-gray-100 p-5 rounded-lg'>
                    <h2 className='text-xl font-bold'><span >Total Amount: </span>{purchased?.totalAmount.toLocaleString("en-IN")}/-</h2>
                    <h2><span className='font-bold'>Payment Method: </span>{purchased?.paymentMethod}</h2>
                    <h2><span className='font-bold'>Date: </span>{new Date(purchased?.date).toLocaleDateString("en-IN")}</h2>

                </div>


            </div>
        </>
    )
}

export default ViewBuying